import routeName from '../constant';

const routes = [
    {
        path: 'value-reserve-isab',
        name: routeName.VALUE_RESERVE_ISAB,
        component: () => import('@/views/aplCatl640and631/AB/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: 'ISAB減少年金保單價值準備金', leaveAlert: true, code: 'AB', unableBack: true },
    }];

export default routes;
